export default __webpack_public_path__ + "static/media/Highlord's Arrows.56a8ee53.jpg";